import { FC } from 'react'

import { Markdown, Popover } from '../atoms'
import { IoInformationCircle } from 'react-icons/io5'
import { primaryIconSize } from '../../lib/styles/universal'
import { colors } from '@hazadapt-git/public-core-base'
import { Typography } from '@mui/material'

interface InfoUsageDisclaimerProps {
    message?: string
    onLinkPress?(url: string): any
}

export const InfoUsageDisclaimer: FC<InfoUsageDisclaimerProps> = () => {
    return (
        <Popover
            icon={
                <IoInformationCircle
                    size={primaryIconSize}
                    color={colors.grays.THUNDERCLOUD}
                />
            }
            buttonContent={
                <Typography sx={{ textDecorationLine: 'underline' }}>
                    How is my information used?
                </Typography>
            }
            popoverPlacement="center"
            popoverContent={
                <Markdown content="We ask you for this information in order to connect you to local disaster preparation resources. We never sell or share personally identifiable information with anyone. [Learn more about how HazAdapt protects your data.](https://www.hazadapt.com/privacy-and-security)" />
            }
        />
    )
}
